import {Modal} from "@mantine/core";

const FirstModal = ({isLoading ,message}) => {
    return (
        <Modal opened={isLoading } onClose={()=>{}} closeOnClickOutside={false} closeOnEscape={false} centered radius="xl" shadow="xl" withCloseButton={false}>
            <div className="p-10 min-w-full min-h-full text-center">
                <span className="animate-pulse text-xl text-greenTwo font-bold"> { message ? message :  'در حال بررسی اطلاعات شما هستیم'} </span>
            </div>
        </Modal>
    )
}
export default FirstModal;